// Single source of truth for enums. UI and Cloud Functions must agree.

export const GAMES = ["BGMI", "PUBGM"];

export const REGIONS = [
  { key: "Global", label: "Global" },
  { key: "India", label: "India" },
  { key: "MENA", label: "MENA / GCC" },
  { key: "SEA", label: "SE Asia" },
  { key: "LATAM", label: "LatAm" },
  { key: "EU", label: "Europe" },
  { key: "NA", label: "North America" },
];

export const SEGMENTS = [
  { key: "mix",        label: "Mix",        cssClass: "mix",
    blurb: "Farmed Pop, lowest rate" },
  { key: "lumen",      label: "Lumen",      cssClass: "lumen",
    blurb: "50k Pop, 7-day animation gift" },
  { key: "helicopter", label: "Helicopter", cssClass: "helicopter",
    blurb: "125k Pop, 14-day animation gift" },
  { key: "premium",    label: "Premium",    cssClass: "premium",
    blurb: "Direct in-game purchase, whale-grade" },
];
export const SEGMENT_KEYS = SEGMENTS.map((s) => s.key);

export const TIERS = [
  { key: "unranked", label: "Unranked", cssClass: "" },
  { key: "1", label: "★1", cssClass: "t1" },
  { key: "2", label: "★2", cssClass: "t2" },
  { key: "3", label: "★3", cssClass: "t3" },
  { key: "4", label: "★4", cssClass: "t4" },
  { key: "5", label: "★5", cssClass: "t5" },
  { key: "6", label: "★6 Crown", cssClass: "t6" },
];

// Tier promotion thresholds — kept identical client + server side.
// Server (Cloud Functions tier engine) is authoritative; client uses these
// only for showing "X more reviews to ★4" hints on the seller dashboard.
export const TIER_RULES = {
  "1": { minReviews: 5,    minRating: 4.0, minDays: 7,   minReserveTier: "none",
    notes: "First-look credibility — verified email + phone" },
  "2": { minReviews: 25,   minRating: 4.3, minDays: 30,  minReserveTier: "none",
    notes: "Active casual seller" },
  "3": { minReviews: 100,  minRating: 4.5, minDays: 30,  minReserveTier: "1M",
    notes: "Trusted small-mid vendor — most buyers default-filter here" },
  "4": { minReviews: 500,  minRating: 4.7, minDays: 60,  minReserveTier: "10M",
    notes: "Reliable mid-volume vendor" },
  "5": { minReviews: 2000, minRating: 4.85, minDays: 90, minReserveTier: "50M",
    notes: "Whale-grade vendor; Dubai-tier buyers comfortable" },
  "6": { manualOnly: true, notes: "Hand-picked Crown vendors — capped globally" },
};

// Reserve proof tiers shown on profile (from stock-screenshot OCR).
export const RESERVE_TIERS = [
  { key: "none", label: "Unverified" },
  { key: "1M",   label: "≥1M reserves" },
  { key: "10M",  label: "≥10M reserves" },
  { key: "50M",  label: "≥50M reserves" },
];

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "ar", label: "العربية" },
  { code: "id", label: "Indonesia" },
  { code: "pt", label: "Português" },
  { code: "es", label: "Español" },
  { code: "zh", label: "中文" },
  { code: "bn", label: "বাংলা" },
  { code: "ta", label: "தமிழ்" },
];

// Display-only — sellers self-declare what they accept. We never process any
// of these on PlayAware's behalf.
export const PAYMENT_METHODS = [
  "UPI", "PayPal", "Wise", "Razorpay", "Stripe",
  "USDT-TRC20", "USDT-BEP20", "Binance Pay", "Bitcoin",
  "Bank Transfer", "Cash on Delivery",
  "GCash", "PIX", "OVO", "Paytm", "Google Pay",
];

export const CONTACT_CHANNELS = [
  { key: "whatsapp", label: "WhatsApp", icon: "💬" },
  { key: "discord",  label: "Discord",  icon: "🎮" },
  { key: "telegram", label: "Telegram", icon: "✈️" },
  { key: "phone",    label: "Phone",    icon: "📞" },
];

export const SELLER_STATUS = ["draft", "pending_review", "active", "paused", "suspended"];
